import React from "react";

// components
import ViewPresensiTentor from "components/Tentor/PresensiView";

export default function Tables() {
  return (
    <>
    <div className="bg-gray-200 min-h-screen py-6 px-4">
      <div className="flex justify-center items-center mt-16">
        <div className="w-full max-w-7xl bg-white  rounded-lg md:p-8">
          <div className="flex flex-wrap">
            <div className="w-full mb-12 px-4">
              <ViewPresensiTentor />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
